import { useFind } from 'src/api/APIHooks';
import { get, upperFirst } from 'lodash';

const usePersonCondition = (contactId, most_recent = false) => {
  const { data: personConditionsData } = useFind(
    `people/${contactId}/person_condition`,
    {
      most_recent,
    },
    {
      queryConfig: {
        placeholderData: undefined,
        enabled: !!contactId,
      },
    },
    );

  const conditions = get(personConditionsData, 'data.data', []);
  return conditions.map((condition) => ({
    ...condition,
    name: upperFirst(condition.sdoh_category ?? condition.name),
  }));
};

export default usePersonCondition;
